import Centro from "./Centro";

export default class CentroView {
    NombreMedicoCentro:string="";
    TipoCentro:string="";
    ProvinciaCentro:string="";
    MunicipioCentro:string="";
}